/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPinSelect = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m23.575 18.023-3.018 1.414-1.418 3.102-2.908-7.27z" />
        <path d="m21.758 9.41-3.187 3.15-2.062-.668-2.763 2.8v4.032l-2.379 2.405-4.11-4.11-4.081 4.083-1.414-1.415 4.082-4.082-4.098-4.097 2.33-2.383H8.21l2.775-2.751-.654-2.085 3.128-3.178zm-9.16-4.574.66 2.102-.433.428-3.793 3.759H4.917l-.358.366 6.8 6.801.387-.39v-4.03l4.206-4.264 2.08.674.89-.88L13.47 3.95z" />
      </g>
    </g>
  </Icon>
);
export { SvgPinSelect as PinSelect };
